import { parse, stringify } from 'query-string';
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

/**
 * 路由 `query` `context` 值
 */
export interface RouterQueryContextValue extends Record<string, any> {}

/**
 * 简单的 `query` 解析函数
 * @param search `search`
 */
export function simpleParse(search: string) {
  return parse(search, {
    parseBooleans: true,
    arrayFormat: 'index',
  });
}

/**
 * 简单的 `query` 序列化函数
 * @param query `query`
 */
export function simpleStringify(query: RouterQueryContextValue) {
  return stringify(query, {
    arrayFormat: 'index',
  });
}

/**
 * 获取路由 `query`
 */
export function useQuery<T extends RouterQueryContextValue = RouterQueryContextValue>() {
  const { search } = useLocation();

  return useMemo(() => {
    return simpleParse(search);
  }, [search]) as T;
}
